import { Branch } from '../../../version-control/branch.model';

export const REPOSITORY_FORM_CONTROL_NAME = 'repository';
export const USER_FORM_CONTROL_NAME = 'user';
export const PASS_FORM_CONTROL_NAME = 'pass';
export const BRANCH_FORM_CONTROL_NAME = 'branch';
export const PATH_FORM_CONTROL_NAME = 'path';

export interface VersionControlForm {
  [REPOSITORY_FORM_CONTROL_NAME]: string;
  [USER_FORM_CONTROL_NAME]?: string;
  [PASS_FORM_CONTROL_NAME]?: string;
  [BRANCH_FORM_CONTROL_NAME]?: Branch | null;
  [PATH_FORM_CONTROL_NAME]: string;
}
